import { Box, VStack } from '@chakra-ui/react'
import { ComponentProps } from 'react'
import { Legend } from 'recharts'

import { ChartBarLegendItem } from '../../common/ChartBarLegendItem'

export const CustomLegend = ({ payload }: ComponentProps<typeof Legend>) => {
  return (
    <Box display="flex" justifyContent="flex-end">
      <VStack alignItems="flex-start" gap="4px">
        {payload
          ?.filter(entry => entry.value)
          .map((entry: any, index: number) => (
            <ChartBarLegendItem
              key={`item-${index}`}
              color={entry.color}
              label={String(entry.value)}
            />
          ))}
      </VStack>
    </Box>
  )
}
